import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import { isEqual } from 'lodash';

import { FilterValueType } from '../filter-types';

import { MIN_DATE, MAX_DATE } from '../../../config/filterOptions/dateRange';
import { getSingleDate } from '../../../utils/dates';

import './styles/SingleDateFilter.css';

export const DATETIMEFORMAT = 'YYYY-MM-DD';
export const SINGLE_DATE_FILTER_ID = 'singleDate'
export const DAY_PRECISION = 'day'


class SingleDateFilter extends React.Component {
  static getDerivedStateFromProps({ value, dates }) {
    return {
      value: value ? moment(value.value) : null
    };
  }

  constructor(...args) {
    super(...args);

    this.state = {
      focused: false
    };

    this.isOutsideRange = this.isOutsideRange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.isDayActive = this.isDayActive.bind(this);
  }

  componentDidMount() {
    const { dates = [] } = this.props;
    if (dates.length > 0) {
      const datesMapping = this.getDatesMapping(dates)
      this.setState({
        datesMapping
      });
    }
  }

  componentDidUpdate({dates: prevDates}) {
    const { dates } = this.props;
    if (dates && !isEqual(dates, prevDates)) {
      const datesMapping = this.getDatesMapping(dates)
      this.setState({
        datesMapping
      });
    }
  }

  getDatesMapping(dates = []) {
    const datesMapping  = dates.reduce((memo, date) => {
      const dateInDateTime = moment(date);
      const dateKey = dateInDateTime.format(DATETIMEFORMAT);
      memo[dateKey] = dateInDateTime;
      return memo;
    }, {});
    return datesMapping;
  }

  onDateChange(date) {
    this.props.onChange(getSingleDate(date));
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }

  // eslint-disable-next-line class-methods-use-this
  isOutsideRange(date) {
    let isOutsideRangeDate;
    const { dates = [] } = this.props;
    if (dates.length > 0) {
      const minDate = dates[0];
      const maxDate = dates[dates.length - 1];
      isOutsideRangeDate = date.isBefore(minDate, DAY_PRECISION) || date.isAfter(maxDate, DAY_PRECISION);
      if (!isOutsideRangeDate) {
        isOutsideRangeDate = !this.isDayActive(date)
      }
    } else {
      const isBeforeDate = d => {
        if (this.props.dataRectriction) {
          return d.isBefore(
            moment().subtract(this.props.dataRectriction, 'months')
          );
        }
        return d.isBefore(MIN_DATE, DAY_PRECISION);
      };
      isOutsideRangeDate = isBeforeDate(date) || date.isAfter(MAX_DATE, DAY_PRECISION);
    }
    return isOutsideRangeDate;
  }

  isDayActive(date) {
    let isActive = false;
    if (this.state.datesMapping) {
      const dateKey = date.format(DATETIMEFORMAT);
      isActive = !!this.state.datesMapping[dateKey];
    }
    return isActive;
  };

  render() {
    const { className, id, placeholder } = this.props;
    const { focused, value } = this.state;

    return (
      <div className={className}>
        <SingleDatePicker
          date={value}
          focused={focused}
          id={id}
          isOutsideRange={this.isOutsideRange}
          onDateChange={this.onDateChange}
          onFocusChange={this.onFocusChange}
          placeholder={placeholder}
          hideKeyboardShortcutsPanel
          noBorder
        />
      </div>
    );
  }
}

SingleDateFilter.propTypes = {
  className: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: FilterValueType, // eslint-disable-line react/no-unused-prop-types
  dates: PropTypes.array
};

SingleDateFilter.defaultProps = {
  value: null
};

export default SingleDateFilter;
